// import { register } from 'register-service-worker'

// if (process.env.NODE_ENV === 'production') {
//   register(`${process.env.BASE_URL}service-worker.js`, {
//     ready (registration) {
//       setInterval(() => registration.update(), 30 * 60 * 1000)
//     },
//     updated () {
//       document.dispatchEvent(new CustomEvent('sw-updated'))
//     },
//     offline () {
//       console.log('No internet connection found. App is running in offline mode.')
//     },
//     error (error) {
//       console.error('Error during service worker registration:', error)
//     }
//   })

//   const hadController = !!navigator.serviceWorker.controller
//   let refreshing = false
//   navigator.serviceWorker.addEventListener('controllerchange', () => {
//     if (!hadController || refreshing) return
//     refreshing = true
//     window.location.reload()
//   })
// }

/* eslint-disable no-console */
import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log("App is being served from cache by a service worker.");
    },
    registered(registration) {
      // کاربری که اپ را باز نگه داشته هم هر ساعت دنبال نسخه جدید بگردد
      setInterval(() => registration.update(), 60 * 60 * 1000);

      // وقتی کاربر از پس‌زمینه به اپ برمی‌گردد (مهم برای نسخه نصبی روی گوشی)
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") registration.update();
      });
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated() {
      // نسخه جدید دانلود شد؛ چون skipWaiting داریم، بلافاصله فعال می‌شود
      // پس با یک رفرش، کاربر نسخه جدید را می‌بیند
      console.log("New content is available; reloading.");
      window.location.reload();
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode.",
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}
